module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-111.3e2f6489.jpg";